import get from 'lodash.get';

const getAvailablePlatformComponents = (rootState) =>
  get(rootState, 'partner.properties.availablePlatformComponents', []);

export default getAvailablePlatformComponents;
